import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { TRTHero } from '../components/trt/TRTHero';
export function TRTPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2660">
      <Navigation data-id="element-2661" />
      <main data-id="element-2662">
        <TRTHero data-id="element-2663" />
      </main>
      <Footer data-id="element-2664" />
    </div>;
}